// extracted by mini-css-extract-plugin
export default {"image":"F2lonM","title":"o4Fpaa","info":"YIZbrz"};